import { render, staticRenderFns } from "./TournamentsList.vue?vue&type=template&id=1ab2acff&scoped=true&"
import script from "./TournamentsList.vue?vue&type=script&lang=js&"
export * from "./TournamentsList.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsList.vue?vue&type=style&index=0&id=1ab2acff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2acff",
  null
  
)

export default component.exports